
/**
 * @const PNP_DOCUMENT_RESET
 * @type {string}
 */
export const PNP_DOCUMENT_RESET = 'PNP_DOCUMENT_RESET';

/**
 * @const PNP_DOCUMENT_DETAILS
 * @type {string}
 */
export const PNP_DOCUMENT_DETAILS = 'PNP_DOCUMENT_DETAILS';

/**
 * @const PNP_DOCUMENT_REVIEWER_APPROVER_DETAILS
 * @type {string}
 */
export const PNP_DOCUMENT_REVIEWER_APPROVER_DETAILS = 'PNP_DOCUMENT_REVIEWER_APPROVER_DETAILS';


/**
 * @const PNP_DOCUMENT_TYPES
 * @type {string}
 */
export const PNP_DOCUMENT_TYPES = 'PNP_DOCUMENT_TYPES';

/**
 * @const PNP_DOCUMENT_CATEGORIES
 * @type {string}
 */
export const PNP_DOCUMENT_CATEGORIES = 'PNP_DOCUMENT_CATEGORIES';

/**
 * @const PNP_DOCUMENT_RISK_LEVELS
 * @type {string}
 */
export const PNP_DOCUMENT_RISK_LEVELS = 'PNP_DOCUMENT_RISK_LEVELS';

/**
 * @const PNP_DOCUMENT_APPLICATION_TYPES
 * @type {string}
 */
export const PNP_DOCUMENT_APPLICATION_TYPES = 'PNP_DOCUMENT_APPLICATION_TYPES';

/**
 * @const PNP_REVIEWER_APPROVER_TYPES
 * @type {string}
 */
export const PNP_REVIEWERS_APPROVERS_TYPES = 'PNP_REVIEWERS_APPROVERS_TYPES';

/**
 * @const PNP_REVIEWERS_CONTACTS
 * @type {string}
 */
export const PNP_REVIEWERS_CONTACTS = 'PNP_REVIEWERS_CONTACTS';

/**
 * @const PNP_ADD_REVIEWERS_CONTACTS
 * @type {string}
 */
export const PNP_ADD_REVIEWERS_CONTACTS = 'PNP_ADD_REVIEWERS_CONTACTS';

/**
 * @const PNP_REMOVE_REVIEWERS_CONTACTS
 * @type {string}
 */
export const PNP_REMOVE_REVIEWERS_CONTACTS = 'PNP_REMOVE_REVIEWERS_CONTACTS';
/**
 * @const PNP_APPROVERS_CONTACTS
 * @type {string}
 */
export const PNP_APPROVERS_CONTACTS = 'PNP_APPROVERS_CONTACTS';

/**
 * @const PNP_ADD_APPROVERS_CONTACTS
 * @type {string}
 */
export const PNP_ADD_APPROVERS_CONTACTS = 'PNP_ADD_APPROVERS_CONTACTS';

/**
 * @const PNP_REMOVE_APPROVERS_CONTACTS
 * @type {string}
 */
export const PNP_REMOVE_APPROVERS_CONTACTS = 'PNP_REMOVE_APPROVERS_CONTACTS';

/**
 * @const PNP_DOCUMENT_STATUSES
 * @type {string}
 */
export const PNP_DOCUMENT_STATUSES = 'PNP_DOCUMENT_STATUSES';

/**
 * @const PNP_ACCREDITATION_SCHEMES
 * @type {string}
 */
export const PNP_ACCREDITATION_SCHEMES = 'PNP_ACCREDITATION_SCHEMES';

/**
 * @const PNP_ACCREDITATION_SECTION
 * @type {string}
 */
export const PNP_ACCREDITATION_SECTION = 'PNP_ACCREDITATION_SECTION';

/**
 * @const SELECT_CASCADE_STANDARD
 * @type {string}
 */
export const PNP_SELECT_CASCADE_STANDARD = 'PNP_SELECT_CASCADE_STANDARD';


/**
 * @const SELECT_CASCADE_STANDARD_RESET
 * @type {string}
 */
export const PNP_SELECT_CASCADE_STANDARD_RESET = 'PNP_SELECT_CASCADE_STANDARD_RESET';


/**
 * @const PNP_ACCREDITATION_DETAILS_ID 
 * @type {string}
 */
export const PNP_ACCREDITATION_DETAILS_ID = 'PNP_ACCREDITATION_DETAILS_ID';

/**
 * @const PNP_HISTORY_DETAILS_ID 
 * @type {string}
 */
export const PNP_HISTORY_DETAILS_ID = 'PNP_HISTORY_DETAILS_ID';